module.exports = __webpack_public_path__ + "img/divider.528fc8d8.svg";